var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://dotnet-api.kaynextechnologies.com';
} else {
    service.API_URL = 'http://192.168.23.145:5001';
}

export default service;
